<template>
  <div>
    <LeftSidebarMarkets
      :newVisibleLeft="userInteractions.newVisibleLeft"
      :hoverVariable="userInteractions.hoverVariable"
      :hoverVariableSubItem="userInteractions.hoverVariableSubItem"
      :newSelectedAnalysis="userSelections.newSelectedAnalysis"
      :newSelectedAnalysisParent="userSelections.newSelectedAnalysisParent"
      :itemsInformation="sidebarData.items"
      @onHoverLeftSidebar="onHoverLeftSidebar"
      @onHoverLeftSidebarSubItem="onHoverLeftSidebarSubItem"
      @onLeftSidebarAnalysis="onLeftSidebarAnalysis"
      @eventOnUserClick="onUserClickLeftSidebarShow"
      @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
      @eventOnClientSelect="eventOnClientSelect"
    />
  </div>
</template>

<script>
import LeftSidebarMarkets from "@/components/sideBars/LeftSidebarMarkets.vue";

export default {
  name: "LeftSidebarCurrencies",
  components: {
    LeftSidebarMarkets
  },
  props: {
    selectedAnalysis: { required: true, default: "" },
    selectedAnalysisParent: { required: true, default: "" },
    selectedSheet: { required: false, default: 0 },
    visibleLeft: { required: true, type: Boolean, default: false }
  },
  data() {
    return {
      userInteractions: {
        hoverVariable: "",
        hoverVariableSubItem: "",
        newVisibleLeft: false
      },
      sidebarData: {
        items: [
          {
            text: "",
            nameEvent: "",
            bdr: false,
            itemHeader: false,
            classNameIcon: "",
            bdrTransition: false
          }
        ]
      },
      userSelections: {
        newSelectedAnalysis: "",
        newSelectedAnalysisParent: ""
      }
    };
  },
  created() {
    this.setItemsSideBar();
  },
  mounted() {
    this.userSelections.newSelectedAnalysis = this.selectedAnalysis;
    this.userSelections.newSelectedAnalysisParent = this.selectedAnalysisParent;
    Object.assign(this["userInteractions"], {
      newVisibleLeft: this.visibleLeft
    });
  },
  watch: {
    selectedAnalysis: {
      handler(newVal) {
        this.userSelections.newSelectedAnalysis = newVal;
      },
      deep: true
    },
    selectedAnalysisParent(val) {
      this.userSelections.newSelectedAnalysisParent = val;
    },
    visibleLeft(val) {
      Object.assign(this["userInteractions"], {
        newVisibleLeft: val
      });
    },
    "sidebarData.items": {
      handler() {},
      deep: true
    }
  },
  methods: {
    // User interactions
    onHoverLeftSidebar(val) {
      Object.assign(this.userInteractions, { hoverVariable: val });
    },
    onHoverLeftSidebarSubItem(val) {
      this.userInteractions.hoverVariableSubItem = val;
    },
    onUserClickLeftSidebarShow() {
      this.$emit("eventOnUserClickLeftSidebarShow", !this.visibleLeft);
    },
    onLeftSidebarAnalysisScenarios() {
      Object.assign(this.userInteractions, { hoverVariable: "" });
    },
    onLeftSidebarAnalysis({ val, parent }) {
      this.$emit("eventOnLeftSidebarAnalysis", { val, parent });
    },
    eventOnClientSelect({ item, nameEvent }) {
      this.$emit("eventOnClientSelect", { idx: item.index, nameEvent });
    },
    // Configuration data
    setItemsSideBar() {
      this.$set(this, "sidebarData", {
        items: [
          {
            text: "Exposures",
            nameEvent: "eventOnClientSelect0",
            bdr: false,
            itemHeader: false,
            classNameIcon: "fa fa-line-chart",
            bdrTransition: false,
            index: 0
          },
          {
            text: "Hedges",
            nameEvent: "eventOnClientSelect1",
            bdr: false,
            itemHeader: false,
            classNameIcon: "fa fa-shield",
            bdrTransition: false,
            index: 1
          },
          {
            text: "Hedging program",
            nameEvent: "eventOnClientSelect2",
            bdr: false,
            itemHeader: false,
            classNameIcon: "fa fa-cogs",
            bdrTransition: false,
            index: 2
          },
          {
            text: "Upload",
            nameEvent: "eventOnClientSelect3",
            bdr: false,
            itemHeader: false,
            classNameIcon: "fa fa-upload",
            bdrTransition: false,
            index: 3
          }
        ]
      });
    }
  }
};
</script>
